function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "CR",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Table-View-|-Survey/year",
  transform: "translate(-1023.000000, -361.000000)",
  fill: "#718492",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "sidebar",
  transform: "translate(1000.000000, 146.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "share",
  transform: "translate(0.000000, 192.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.5,23 C46.7375,23 47.75,24.00125 47.75,25.25 L47.75,25.25 L47.73875,36.5 C47.73875,37.7375 46.7375,38.75 45.5,38.75 L45.5,38.75 L50,38.75 L50,41 L23,41 L23,38.75 L27.5,38.75 C26.25125,38.75 25.25,37.7375 25.25,36.5 L25.25,36.5 L25.25,25.25 C25.25,24.00125 26.25125,23 27.5,23 L27.5,23 Z M39.3333333,26 C38.4111111,26 37.6666667,26.7399598 37.6666667,27.6566265 C37.6666667,27.7891566 37.6888889,27.9161647 37.7166667,28.0431727 L33.8,30.312751 C33.5,30.0366466 33.1055556,29.8654618 32.6666667,29.8654618 C31.7444444,29.8654618 31,30.6054217 31,31.5220884 C31,32.438755 31.7444444,33.1787149 32.6666667,33.1787149 C33.1055556,33.1787149 33.5,33.0075301 33.8,32.7314257 L37.7555556,35.0286145 C37.7277778,35.1445783 37.7111111,35.2660643 37.7111111,35.3875502 C37.7111111,36.2766064 38.4388889,37 39.3333333,37 C40.2277778,37 40.9555556,36.2766064 40.9555556,35.3875502 C40.9555556,34.498494 40.2277778,33.7751004 39.3333333,33.7751004 C38.9111111,33.7751004 38.5333333,33.9407631 38.2444444,34.2003012 L34.2833333,31.9086345 C34.3111111,31.7816265 34.3333333,31.6546185 34.3333333,31.5220884 C34.3333333,31.3895582 34.3111111,31.2625502 34.2833333,31.1355422 L38.2,28.8659639 C38.5,29.1420683 38.8944444,29.313253 39.3333333,29.313253 C40.2555556,29.313253 41,28.5732932 41,27.6566265 C41,26.7399598 40.2555556,26 39.3333333,26 Z"
})))));

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "18px",
    viewBox: "0 0 27 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.15c27cef.svg";
export { ForwardRef as ReactComponent };